// Single source of truth for route (first path segment) -> Spanish display
// title. Consumed by the sidebar menu (Sider), the header section title, and
// the document.title updater in the Layout wrapper. Do not duplicate this
// mapping elsewhere — update it here and every consumer stays in sync.
export const ROUTE_TITLES: Record<string, string> = {
  "/": "Inicio",
  "/programs": "Programas",
  "/courses": "Cursos",
  "/lessons": "Lecciones",
  "/resources": "Recursos",
  "/mapa-contenido": "Mapa de contenido",
  "/atencion": "Necesita atención",
  "/game-quizzes": "Quizzes Emmi",
  "/quiz-retrieval": "Búsqueda de quizzes",
  // Covers both tabs of the page: quiz sessions and finished game rounds.
  "/attempts": "Sesiones",
  "/recursos-prueba": "Recursos de prueba",
  "/revision-ods": "Revisión de ODs",
  "/users": "Usuarios",
  "/schools": "Escuelas",
  "/subjects": "Asignaturas",
  "/grades": "Grados",
  "/calendar": "Calendario",
  "/diary-teacher": "Diario del Maestro",
  "/formacion": "Formación",
  "/tienda-paquetes": "Tienda · Paquetes",
  "/ventas": "Ventas",
  "/subidor-supersonico": "Subidor Supersónico",
  // Uploads and downloads of content share this page, under the same route.
  "/hub-subida": "HUB contenido",
  "/game-diagnostics": "Diagnósticos",
  "/demo-provision": "Demo",
  "/papelera": "Papelera",
  "/actividad": "Actividad",
  // Natural-language questions over the read-only data views (docs/consultas-de-datos.md
  // in emmi-backend). Two routes share the title: /consultas and /consultas/:threadId.
  "/consultas": "Consultas de datos",
  "/progreso-profesores": "Progreso de profesores",
  // Only rendered for "administradores principales" (SCRUM-706), but the
  // title mapping stays unconditional: Header and document.title read it for
  // whoever manages to reach the route.
  "/accesos": "Accesos",
  // Published-version table read by the installed apps to decide whether to
  // show their update notice (SCRUM-720).
  "/version-app": "Versión de la app",
  "/settings": "Configuración",
};
